import { createFileRoute } from '@tanstack/react-router'
import { ResellerWhitelabelPage } from '@/features/reseller/pages/whitelabel'

export const Route = createFileRoute('/_authenticated/reseller/whitelabel')({
  component: ResellerWhitelabelPage,
})
